import * as React from 'react';

import { cleansePhoneNumber, formatPhoneNumberInput } from '../../../helpers/formatUtils';
import TextExtender from '../TextExtender';

import './ContactInfoRowStyle.less';

export interface IContactInfoRowProps {
  className?: string;
  email?: string;
  label: string;
  name: string;
  phone?: string;
}

export default class ContactInfoRow extends React.PureComponent<IContactInfoRowProps> {
  public render() {
    const { className, email, label, name, phone } = this.props;
    const emailLink = `mailto:${email}`;

    return (
      <div className={`contact-info-row row ${className || ''}`}>
        <div className="contact-info-row-label col-md-3">{label}</div>
        <div className="col-md-3">{name}</div>
        <div className="contact-info-row-email col-md-3">
          {email ? <TextExtender link={emailLink} text={email} /> : null}
        </div>
        <div className="contact-info-row-phone col-md-3">
          {phone ? (
            <a href={`tel:${cleansePhoneNumber(phone)}`}>{formatPhoneNumberInput(phone)}</a>
          ) : null}
        </div>
      </div>
    );
  }
}
